import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../CSS/General.css'
import '../CSS/HomePage.css'
import { RiAdminFill } from "react-icons/ri";
import { HiMiniComputerDesktop } from "react-icons/hi2";
import { BsFillBoxSeamFill } from "react-icons/bs";
import { AiOutlineFileDone } from "react-icons/ai";
import { useTranslation } from 'react-i18next';
function HomePage() {
  const { t } = useTranslation();
  const user = JSON.parse(localStorage.getItem('user'));
  const navigate = useNavigate();

  useEffect(() => {
    if (user && user.UserType.includes('Admin')) {
      navigate('/admin/auctions/current');
    }
  }, []);

  return (
    <div className="flex-grow container py-4 mx-auto">
      <h1 className="title homepage-title">{t('Welcome to the Home Page')}</h1>
      <div className="grid grid-cols-1 gap-6">
        <div className="bg-white p-6 rounded-lg shadow-md text-center home-admin-hover home-role-btn" onClick={() => window.location.href = '/admin/auctions/current'}>
          <RiAdminFill className="text-5xl mb-4 w-full" />
          <h2 className="text-xl font-semibold mb-2">{t('Admin')}</h2>
          <p>{t('Manage system settings and user accounts')}</p>
        </div>
      </div>
    </div>
  );

}
export default HomePage;